import { useTranslation } from 'react-i18next';

import { Alert, Box, Typography } from '@mui/material';

type Props = {
	/** Why the API refused the request, as it answered it. */
	message: string;
	/** The cards it named, each with its reason, when the refusal was about the cards. */
	failures: { index: number; reason: string }[] | null;
	/**
	 * How to name the card at a position of the request. The API names a refused card by its
	 * position, never by its UID (MUTE-606). By default, its number in the request.
	 */
	cardName?: (index: number) => string;
};

/** A refused load or batch: the API's message and, below it, every card it named and why. */
export default function NfcCardFailures({ message, failures, cardName }: Props) {
	const { t } = useTranslation();

	const nameOf = (index: number) => (cardName ? cardName(index) : t('nfc:cardNumber', { number: index + 1 }));

	return (
		<Alert severity="error" sx={{ mb: 2 }}>
			<Typography>{message}</Typography>
			{!!failures?.length && (
				<Box component="ul" sx={{ m: 0, pl: 2 }}>
					{failures.map((failure) => (
						<li key={failure.index}>
							<Typography component="span">{nameOf(failure.index)}</Typography>: {failure.reason}
						</li>
					))}
				</Box>
			)}
		</Alert>
	);
}
